var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loader"},[_c('img',{attrs:{"src":_vm.loaderIcon}}),_c('span',{staticClass:"ml-2"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }